<template>
  <form class="search" @submit.prevent="search">
    <span class="icon icon-search"></span>
    <input
      :disabled="disabled"
      v-model.trim="value"
      :placeholder="placeholder || '请输入搜索内容'"
    />
    <span
      class="empty"
      @click="emptyInput"
      v-if="enableEmpty && !!value"
    >
      <span class="icon-close"></span>
    </span>
  </form>
</template>

<script>
import './search.scss'

export default {
  props: {
    placeholder: { // 提示语
      type: String,
      default: '请输入搜索内容',
    },
    enableEmpty: { // 是否可以清空
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false
    },
    defaultValue: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      value: ''
    }
  },
  methods: {
    emptyInput() {
      this.value = ''
    },
    search() {
      this.$emit('submit', this.value)
    }
  },
  watch: {
    'defaultValue' (v) {
      this.value = v
    },
    'value' (nValue) {
      this.$emit('submit', this.value)
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/Search/Search.vue